import styled from 'styled-components';
import theme from '../../../theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 30px;


    span {
        font-size: 12px;
        font-weight: 400;
        color: ${theme.textDark};
    }

    form {
        width: 100%;

        > div + div {
            margin-top: 10px;
        }
    }

    button {
        margin: 20px 0 0 auto;
    }
`;

const CheckPasswordRow = styled.div`
    margin-bottom: 20px;

    p {
        font-size: 12px;
        font-weight: 400;
        color: ${theme.textDark};
        margin-bottom: 10px;
    }
`;

export { Container, CheckPasswordRow };